import { render, staticRenderFns } from "./ringkas.vue?vue&type=template&id=2cc174e2&"
import script from "./ringkas.vue?vue&type=script&lang=js&"
export * from "./ringkas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports